<template>

  <v-app light>

    <v-content :style="'background: #2E7D32 url(\'/static/img/background.png\') repeat;'">

      <v-container fluid grid-list-lg>

        <v-layout row wrap>

          <v-flex xs12>
             <p class="text-xs-center my-4">
              <vue-responsive-image :image-url="'/static/img/logo.png'" :width-on-screen="25" :width-on-screen-tablet="45" :width-on-screen-smartphone="85" :image-ratio="16/9" :alt="'Arbopasto'" :image-class="'vw50'" :mode="'all'"></vue-responsive-image>
            </p>
          </v-flex>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-title primary-title>
                <div class="headline">Bem-vind@ ao Arbopasto!</div>
              </v-card-title>
              <v-card-text>
                <p>
                  Acesse nosso catálogo de árvores e encontre a melhor opção para arborizar sua pastagem.
                </p>
              </v-card-text>
              <v-btn @click="treeCatalog()" large color="purple" class="white--text" block>
                <v-icon dark left>local_florist</v-icon>
                Catálogo de Árvores
              </v-btn>
            </v-card>
           
          </v-flex>
          <v-flex xs12>
            <p class="text-xs-center my-4">
              <img src="/static/img/embrapa-white.png" style="width: 150px;" alt="Logo da Embrapa" />
            </p>
          </v-flex>

        </v-layout>

        <install></install>

        <beta></beta>
        
      </v-container>

    </v-content>

  </v-app>

</template>

<script>
import VueResponsiveImage from 'vue-responsive-image'

import Install from '../components/Install'
import Beta from '../components/Beta'

export default {
  components: {
    VueResponsiveImage,
    Install,
    Beta
  },
  data () {
    return {}
  },
  methods: {
    treeCatalog () {
      this.$router.push('/trees')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue